import { InstallmentsRow } from './InstallmentsRow';

export const InstallmentsTable = ({ installments }) => (
  <div className="col-12 table-responsive">
    <table className="table table-striped table-hover installments-table">
      <thead>
        <tr className="text-center">
          <th scope="col">Parcela</th>
          <th scope="col">Vencimento</th>
          <th scope="col">Valor Total</th>
          <th scope="col">Pagamento</th>
          <th scope="col">Status</th>
          <th scope="col">Ações</th>
        </tr>
      </thead>
      <tbody>
        {installments.map(installment => (
          <InstallmentsRow
            installment={installment}
            key={installment.Parcela}
          />
        ))}
      </tbody>
    </table>
  </div>
);
